/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ amount: NonNullable<unknown> }} Ticketsfreewithdoorprice4Inputs */

const en_ticketsfreewithdoorprice4 = /** @type {(inputs: Ticketsfreewithdoorprice4Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Free, ${i?.amount} at the door`)
};

const de_ticketsfreewithdoorprice4 = /** @type {(inputs: Ticketsfreewithdoorprice4Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Kostenlos, ${i?.amount} vor Ort`)
};

/**
* | output |
* | --- |
* | "Free, {amount} at the door" |
*
* @param {Ticketsfreewithdoorprice4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketsfreewithdoorprice4 = /** @type {((inputs: Ticketsfreewithdoorprice4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketsfreewithdoorprice4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketsfreewithdoorprice4(inputs)
	return de_ticketsfreewithdoorprice4(inputs)
});
export { ticketsfreewithdoorprice4 as "ticketsFreeWithDoorPrice" }